<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // props
  export let verificationStatuses: string[] = [];
  export let showMicrodepositModal: boolean = false;

  const closeModal = () => {
    showMicrodepositModal = false;
  };

  const getText = (statuses: string[]) => {
    return statuses.includes("pending_manual_verification")
      ? `In order to verify your bank account we will be making two deposits in your account from “Provi ACCTVERIFY” 
    within in 1-2 business days. You will need to enter the micro deposit amounts on the Payment Settings page. 
    You will not be able to pay invoices with this payment method until this action is complete.`
      : `In order to verify your bank account we will be making two deposits in your account from “Provi ACCTVERIFY” 
    within in 1-2 business days. You will be emailed once we are able to verify, you can check the status on the 
    Payment Settings page. You will not be able to pay invoices with this payment method until verification is complete.`;
  };

  $: text = getText(verificationStatuses);

</script>

<Modal show={showMicrodepositModal} closeOnBackgroundClick={true} fizzModal={true} size={"medium"}>
  <section class="fizz-inset-square-24" data-testid="dwolla-microdeposit-modal">
    <header class="fizz-space-between fizz-stack-16">
      <h4 class="fizz-heading-4">Account Verification</h4>
      <div on:click|preventDefault={closeModal}>
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
      </div>
    </header>
    <div class="fizz-flow-16 fizz-stack-8">
      <p class="fizz-text-left" data-testid="microdeposit-text">{text}</p>
    </div>
    <footer class="fizz-flex-row fizz-justify-end">
      <button class="fizz-button-secondary fizz-button" on:click|preventDefault={closeModal}>
        Okay
      </button>
    </footer>
  </section>
</Modal>
